var map = {
	"./amazon-eventbridge.svg": 23890,
	"./amazon.securitylake.svg": 46987,
	"./anomali.svg": 65229,
	"./anthropic-light.svg": 93389,
	"./anthropic.svg": 91446,
	"./apache.svg": 90056,
	"./appomni.svg": 48296,
	"./asana.svg": 66536,
	"./atlassian.svg": 59490,
	"./auditd.svg": 1225,
	"./auth0-light.svg": 42067,
	"./auth0.svg": 58760,
	"./aws-cloudwatch-logs.svg": 40894,
	"./aws-light.svg": 6562,
	"./aws-s3.svg": 86960,
	"./aws-sqs.svg": 39533,
	"./aws.alb.svg": 50512,
	"./aws.auroramysql.svg": 31917,
	"./aws.cloudfront.svg": 58425,
	"./aws.cloudtrail.svg": 2416,
	"./aws.cloudwatchEvents.svg": 68294,
	"./aws.config.svg": 22199,
	"./aws.eks.svg": 44180,
	"./aws.guardduty.svg": 83984,
	"./aws.nlb.svg": 37463,
	"./aws.s3server.svg": 19278,
	"./aws.securityhub.svg": 81280,
	"./aws.svg": 98233,
	"./aws.transitGatewayFlow.svg": 8952,
	"./aws.vpc.svg": 22546,
	"./aws.wafwebacl.svg": 44439,
	"./axonius-light.svg": 73472,
	"./axonius.svg": 13043,
	"./azure-blob.svg": 59785,
	"./azure-eventhub.svg": 64061,
	"./azure.audit.svg": 63588,
	"./azure.monitor.svg": 23167,
	"./bedrock_model_invocation.svg": 4911,
	"./bitwarden.svg": 99804,
	"./box.svg": 40141,
	"./carbonblack-light.svg": 82685,
	"./carbonblack.svg": 14278,
	"./carbonblackAudit-light.svg": 65756,
	"./carbonblackAudit.svg": 11343,
	"./carbonblackDataStreaming-light.svg": 97841,
	"./carbonblackDataStreaming.svg": 87322,
	"./cisco.svg": 58419,
	"./claude-code.svg": 52530,
	"./claude-cowork.svg": 27364,
	"./cloudflare.svg": 59727,
	"./cloudwatch.svg": 13482,
	"./crowdstrike.svg": 56839,
	"./crowdstrikeEventStreams.svg": 41324,
	"./cursor.svg": 29459,
	"./databricks.svg": 41584,
	"./docker.svg": 89714,
	"./docusign-light.svg": 88345,
	"./docusign.svg": 77218,
	"./dropbox.svg": 11272,
	"./duo.svg": 87066,
	"./envoy.svg": 20191,
	"./fastly.svg": 68829,
	"./fluentd.svg": 34872,
	"./gcp-gcs.svg": 38902,
	"./gcp-pubsub.svg": 12432,
	"./gcp.svg": 18828,
	"./gcs.svg": 90527,
	"./github-light.svg": 96752,
	"./github.svg": 34883,
	"./githubAuditStreaming-light.svg": 14815,
	"./githubAuditStreaming.svg": 13108,
	"./githubWebhooks-light.svg": 57322,
	"./githubWebhooks.svg": 88289,
	"./gitlab.svg": 95120,
	"./googlethreatintelligence.svg": 24326,
	"./greynoise-light.svg": 26672,
	"./greynoise.svg": 60035,
	"./gsuite.svg": 42971,
	"./heroku.svg": 67078,
	"./hexWebhook.svg": 46444,
	"./http-ingest-light.svg": 34548,
	"./http-ingest.svg": 49127,
	"./iru.svg": 65124,
	"./island.svg": 76053,
	"./jamfpro.svg": 7125,
	"./juniper-light.svg": 24044,
	"./juniper.svg": 66655,
	"./lacework.svg": 33924,
	"./lacework_alert_channel.svg": 32115,
	"./log-forwarder.svg": 62329,
	"./m365.svg": 56369,
	"./material-cases.svg": 47537,
	"./microsoftdefenderxdr.svg": 7023,
	"./microsoftgraph.svg": 21638,
	"./microsoftintune.svg": 69145,
	"./mongodb.svg": 95964,
	"./netskope-light.svg": 71050,
	"./netskope.svg": 59617,
	"./nginx.svg": 63266,
	"./notion.svg": 37689,
	"./okta.svg": 31185,
	"./oktaLogStreaming.svg": 73047,
	"./onelogin-light.svg": 25446,
	"./onelogin.svg": 44381,
	"./onepassword.svg": 45317,
	"./openai-light.svg": 57747,
	"./openai.svg": 97768,
	"./orca-light.svg": 40454,
	"./orca.svg": 24509,
	"./osquery.svg": 73608,
	"./ossec.svg": 23771,
	"./otlp-ingest.svg": 2568,
	"./otx.svg": 40625,
	"./paloAltoNGFW.svg": 53836,
	"./proofpoint-light.svg": 30645,
	"./proofpoint.svg": 14270,
	"./pushsecurity.svg": 4236,
	"./rapid7.svg": 72219,
	"./s3.svg": 78064,
	"./salesforce.svg": 40439,
	"./salesforceRealtime.svg": 88740,
	"./sentinelOne.svg": 63530,
	"./sentinelOneApi.svg": 56534,
	"./sentinelOneCloudFunnel.svg": 77897,
	"./sentinelOneCloudFunnelV2.svg": 61245,
	"./slack.svg": 76214,
	"./snowflakeaudit.svg": 86207,
	"./snyk.svg": 60497,
	"./socradar.svg": 14617,
	"./sophos.svg": 79402,
	"./sqs.svg": 68781,
	"./sublime-light.svg": 78520,
	"./sublime.svg": 80235,
	"./suricata.svg": 47524,
	"./sysdig.svg": 33455,
	"./syslog.svg": 44853,
	"./tailscale-light.svg": 25217,
	"./tailscale.svg": 65930,
	"./taxii.svg": 54207,
	"./teleport.svg": 47743,
	"./tenable-light.svg": 53592,
	"./tenable.svg": 30827,
	"./thinkst_canary.svg": 54194,
	"./tines-light.svg": 30584,
	"./tines.svg": 36651,
	"./tracebit.svg": 94390,
	"./upwind.svg": 52995,
	"./vercel-light.svg": 38968,
	"./vercel.svg": 75499,
	"./virustotal.svg": 33909,
	"./windowseventlogs.svg": 90402,
	"./wiz.svg": 91896,
	"./wizWebhook.svg": 94547,
	"./workato.svg": 89557,
	"./workday.svg": 15905,
	"./zeek-light.svg": 18142,
	"./zeek.svg": 23669,
	"./zendesk-light.svg": 25729,
	"./zendesk.svg": 26058,
	"./zoom.svg": 48547,
	"./zscalerZIA.svg": 28484,
	"./zscalerZPA.svg": 99107
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4908;